export default __webpack_public_path__ + "static/media/activity_word_search_small.376a5c28.png";